import { withType } from '../../../../utils/actionOperations';
import {UPDATE_TREND_HEATMAP_SCORE_LEVEL,
  UPDATE_TREND_HEATMAP_COMPARISON_LEVEL} from '../../../constants';

export * from './TrendHeatmapQuestionsAction';
export * from './TrendHeatmapTableAction';
export * from './TrendHeatmapResetFetchDataKeyAction'

export const updateTrendScoreLevel = (params) => {
  return withType(UPDATE_TREND_HEATMAP_SCORE_LEVEL, {
    data: params.scoreLevel,
  });
};

export const updateTrendComparisonLevel = (params) => {
  return withType(UPDATE_TREND_HEATMAP_COMPARISON_LEVEL, {
    data: params.comparisonLevel,
  });
};
